import { ArchivingExportDateType }            from '@app/modules/archiving/models/archiving-common.model';
import { IArchivingTssLogExportEntityEvents } from '@core/interfaces/entity.interface';


// ENUMS #############################################################
// API enums *********************************************************
export enum ArchivingTssLogExportStatusEnum {
	CANCELLED = 'CANCELLED',
	COLLECTING = 'COLLECTING',
	DELETED = 'DELETED',
	ERROR = 'ERROR',
	GENERATING = 'GENERATING',
	PENDING = 'PENDING',
	READY = 'READY'
}

// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ArchivingTssLogExportTMO {
	public businessPremisesId?: string = undefined;

	public created?: Date = undefined;

	public createdBy?: string = undefined;

	public expiration?: Date = undefined;

	public extendable?: boolean = undefined;

	public filesize?: number = undefined;

	public id?: string = undefined;

	public lastModified?: Date = undefined;

	public lastModifiedBy?: string = undefined;

	public result?: ArchivingTssLogExportResult = undefined;

	public status?: ArchivingTssLogExportStatusEnum = undefined;
}

export class ArchivingTssLogExportResultTMO {
	public url?: string = undefined;
}

export class CreateArchivingTssLogExportBodyTMO {
	public tssLogIds?: string[] = undefined;
	public businessDateRange?: ArchivingTssLogExportDateRange = undefined;
	public createdDateRange?: ArchivingTssLogExportDateRange = undefined;
	public webhook?: Webhook = undefined;
}

export class WebhookTMO {
	public url?: string = undefined;
	public secret?: string = undefined;
}

export class ArchivingTssLogExportDateRangeTMO {
	public from?: string = undefined;
	public to?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingTssLogExport extends ArchivingTssLogExportTMO {
	public ui?: IArchivingTssLogExportEntityEvents = {
		daysLeftUntilExpire: undefined
	};
}

export class ArchivingTssLogExportResult extends ArchivingTssLogExportResultTMO {}

export class CreateArchivingTssLogExportBody extends CreateArchivingTssLogExportBodyTMO {}

export class Webhook extends WebhookTMO {}

export class ArchivingTssLogExportDateRange extends ArchivingTssLogExportDateRangeTMO {}

export class ArchivingTssLogExportDateRequest {
	public dateType?: ArchivingExportDateType = undefined;
	public dateFrom?: Date = undefined;
	public dateTo?: Date = undefined;
}
